import { pathRedirect } from '@/utils/auth'

import WaterUser from '@/containers/Base/WaterUser'
import Book from '@/containers/Base/Book'

export default {
  path: 'base',
  redirect: pathRedirect,
  children: [
    { path: 'waterUser/:id', component: WaterUser },
    { path: 'book', component: Book }
  ],
  component: {
    template: '<router-view></router-view>'
  }
}



// WEBPACK FOOTER //
// ./src/router/base.js